import {User} from '../../models/user';
import {BijbError} from '../../models/bijb-error';
import {LoadableState} from './loadable-state';
import {autoserializeAs, inheritSerialization} from 'cerialize';

@inheritSerialization(LoadableState)
export class UsersState extends LoadableState {
  public static readonly key = 'UsersState';

  @autoserializeAs(User, 'users')
  public users: User[] = [];

  @autoserializeAs(BijbError, 'error')
  public error: BijbError = null;

}
